import Pro1 from "./Projects/Projs";


const Projects = () =>{
    return(
        <>
            <div className="project" id="project">
            <h1 className="project_title">My Projects </h1>
            <div className="cards_set">
            <Pro1/>
            </div>
        </div>


        </>
    )
}
export default Projects